import { IClonable } from "./IClonable";
import { ObjectId } from "../ObjectId";

export interface IItem extends IClonable<IItem> {
  privateId: number;
  typeKey: string;
  typeDetail: string;
  id: string;
  uniqueKey: string;
  sectionObjectUid: string;
  isEditable: boolean;
  isAdditional: boolean;
  isDeleted: boolean;
  viewTitle: string;
  // IRelationalとか追加しようかと思ったが、interface実装有無は動的に判定できないので基底クラスに実装.
  initialize(
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean)) => IItem[]
  ): IItem;
  handleItemUpdated(
    originalItem: IItem,
    updatedItem: IItem,
    isInSameSection: boolean,
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]
  ): IItem;
  handleOwnUpdated(
    originalItem: IItem,
    itemAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem,
    itemsAccessor: (finder?: ObjectId | string | ((i: IItem) => boolean), isSameSectionOnly?: boolean) => IItem[]
  ): IItem;
}

export function instanceOfIItem(instance: any): instance is IItem {
  return instance
      && (instance.privateId !== undefined)
      && (instance.typeKey !== undefined)
//      && (instance.id !== undefined)  // idはundefinedがありえる.
//      && (instance.uniqueKey !== undefined)  // uniqueKeyはundefinedがありえる.
//      && (instance.sectionObjectUid !== undefined)  // sectionObjectUidはundefinedがありえる.
      && (instance.isEditable !== undefined)
      && (instance.isAdditional !== undefined)
      && (instance.initialize !== undefined)
      && (instance.handleItemUpdated !== undefined)
      && (instance.handleOwnUpdated !== undefined);
}
